import React from 'react';

import {
  Breakpoints,
  CustomImage,
  Gallery,
  GallerySlide,
  Lentils,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
  useIsMobile,
} from '@vw-marketing/us-components';

import { AppConstants } from '../../../utils/app-constants';
import { OfferInformation } from '../../../hooks-store/typings/incentive-store';
import { SalesEventSkeletonCard } from '../skeleton-card/SalesEventSkeletonCard';
import {
  SalesEventLogoWrapper,
  StyledGalleryWrapper,
  StyledImageCard,
  StyledLentilsContainer,
  StyledOfferInformationWrapper,
  StyledOffersWrapper,
  StyledSalesEventCardWrapper,
  StyledSalesEventHeaderWrapper,
  StyledSalesOfferCardWrapper,
} from './styled';
import { useFeatureAppContent } from '../../../hooks/use-feature-app-content';

export const LoadingSalesCard = ({
  specialOffers,
}: {
  readonly specialOffers: OfferInformation[];
}) => {
  const isTablet: boolean = useIsMobile(Breakpoints.b1280);
  const { sales_event_logo_url_light } = useFeatureAppContent();

  return (
    <div role="loading-card">
      <StyledSalesEventCardWrapper>
        {sales_event_logo_url_light && isTablet && (
          <StyledSalesEventHeaderWrapper>
            <SalesEventLogoWrapper>
              <CustomImage
                src={sales_event_logo_url_light}
                alt="Sales_Event_Logo"
                srcPlaceholder={AppConstants.PlaceHolder480x216 as string}
              />
            </SalesEventLogoWrapper>
          </StyledSalesEventHeaderWrapper>
        )}
        <StyledOffersWrapper>
          <TextCustom
            appearance={TextAppearance.label100}
            tag={TextTag.span}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize20,
                lineHeight: TextLineHeight.TextLineHeight32,
                color: TextColor.inherit,
                fontWeight: TextWeight.regular,
              },
            }}
          >
            <TextCustom
              appearance={TextAppearance.label100}
              tag={TextTag.span}
              style={{
                [Breakpoints.default]: {
                  fontSize: TextSize.TextSize20,
                  lineHeight: TextLineHeight.TextLineHeight32,
                  color: TextColor.inherit,
                  fontWeight: TextWeight.bold,
                },
              }}
            >
              1 of {specialOffers.length}{' '}
            </TextCustom>
            Offers
          </TextCustom>
        </StyledOffersWrapper>
        <StyledGalleryWrapper>
          <Gallery
            id="offers-gallery"
            aria-label="My Gallery"
            ariaLabelledby="gallery-label"
            bottomElements={
              <StyledLentilsContainer>
                <Lentils />
              </StyledLentilsContainer>
            }
            fadingEdges={isTablet ? 'auto' : 'none'}
          >
            <GallerySlide
              ariaLabelledby="slide 1"
              aria-label="Slide description 1"
            >
              <StyledSalesOfferCardWrapper>
                <StyledImageCard />
                <StyledOfferInformationWrapper>
                  <SalesEventSkeletonCard />
                </StyledOfferInformationWrapper>
              </StyledSalesOfferCardWrapper>
            </GallerySlide>
          </Gallery>
        </StyledGalleryWrapper>
      </StyledSalesEventCardWrapper>
    </div>
  );
};
